import { useSearchParams } from "react-router-dom";

const useSearchParameter = (
  key: string
): [string | null, (value: string | number | null) => void] => {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = searchParams.get(key);

  const setValue = (newValue: string | number | null) => {
    if (newValue) {
      searchParams.set(key, String(newValue));
    } else {
      searchParams.delete(key);
    }
    setSearchParams(searchParams);
  };

  return [value, setValue];
};

export default useSearchParameter;
